import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageSwitchService } from 'src/app/services/language-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { ProductService } from 'src/app/services/product.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {
  @Input() flow: string = ''
  currentLanguage: string = '';
  clearanceData :any;
  URLS: any;
  ENV:any;

 
  constructor(
    private UTS: UtilitiesService,
    private aRoute:ActivatedRoute,
    private LSS: LanguageSwitchService,
    private translate: TranslateService,
    private route:Router,
    private PS :ProductService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer

  ) {
    this.aRoute.queryParams.subscribe((q)=>{
      if (
        (q && q.lang && q.lang.toLowerCase() == 'ar') ||
        (q && q.locale && q.locale.toLowerCase() == 'ar')
      ) {
        this.LSS.setLanguage(
          q.locale
            ? q.locale.toLowerCase()
            : q.lang
            ? q.lang.toLowerCase()
            : 'ar'
        );
        
        this.translate.setDefaultLang('ar');
      } else if (
        (q && q.lang && q.lang.toLowerCase() == 'en') ||
        (q && q.locale && q.locale.toLowerCase() == 'en')
      ) {
        this.LSS.setLanguage(
          q.locale
            ? q.locale.toLowerCase()
            : q.lang
            ? q.lang.toLowerCase()
            : 'en'
        );
        this.translate.setDefaultLang('en');
      } else {
        this.LSS.setLanguage(
          this.UTS.getLocaleLanguage().toLocaleLowerCase()
        );
        this.translate.setDefaultLang('en');
      }
    })
    this.currentLanguage = this.UTS.getLocaleLanguage();

  }

  ngOnInit() {
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.ENV = this.UTS.getENV();
    this.clearanceData = JSON.parse(localStorage.getItem('clearancePayload'));
    this.getNAVURLs();
  }

  gotoHome(){
    const url = '/clearance-login'
    this.route.navigate([url]);
  }

  getNAVURLs() {
    const lang = this.UTS.getLocaleLanguage();
    if (lang === 'ar') {
      this.URLS = {
        APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
        APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
        APPLICATION_NAVIATION_URL: 'ar' + AppSettings.APPLICATION_NAVIATION_URL,
        APPLICATION_QLINKS_FOOTER_URL:
          'ar' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
      };
    } else {
      this.URLS = {
        APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
        APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
        APPLICATION_NAVIATION_URL: 'en' + AppSettings.APPLICATION_NAVIATION_URL,
        APPLICATION_QLINKS_FOOTER_URL:
          'en' + AppSettings.APPLICATION_QLINKS_FOOTER_URL,
      };
    }
    this.PS.getCMSContent(
      this.URLS.APPLICATION_QLINKS_FOOTER_URL,
      'GET'
    ).subscribe(
      (res: any) => {
        let response = res.htmlSrc.toString();
        response = this.sanitizer.bypassSecurityTrustHtml(response);
        response = response.changingThisBreaksApplicationSecurity;
        this.cdr.detectChanges();
      },
      (e) => {}
    );

    this.PS.getCMSContent(this.URLS.APPLICATION_FOOTER_URL, 'GET').subscribe(
      (res: any) => {
        let response = res.htmlSrc.toString();
        response = this.sanitizer.bypassSecurityTrustHtml(response);
        response = response.changingThisBreaksApplicationSecurity;
        this.cdr.detectChanges();
      },
      (e) => {}
    );
  }


  format(data: any) {
    return data ? this.UTS.format(data) : data;
  }


}
